/**
 * api.js - API 模块
 * 支持 Mock 模式和真实后端模式（使用 axios）
 */

import axios from 'axios';

// 切换为 true 时使用 Mock 数据，false 时使用真实后端
const USE_MOCK = false;

// 后端接口基础地址
const API_BASE = '';

// 创建 axios 实例
const request = axios.create({
  baseURL: API_BASE,
  timeout: 10000,
});

// 请求拦截器：自动注入 Device-Id 请求头
request.interceptors.request.use(function (config) {
  config.headers['Device-Id'] = getDeviceId();
  return config;
});

// ================================================================
// Mock 数据 - 页面配置
// ================================================================
const MOCK_CONFIG = {
  topbar_config: {
    avatar: 'https://givelove.cn/img/20260802231931.jpg',
    title: '予爱の世界',
    buttonText: '点击进入予爱の世界',
    buttonUrl: 'https://fm.missevan.com/live/869109850',
  },
  page_config: {
    title: '予爱の世界',
    subtitle: '予爱悠悠，声声为你',
    description: '本页面所有歌手均在予爱の世界排档直播，营业时间 8:00-24:00，欢迎前来收听 o(*≧▽≦*)ツ',
    liveRoomUrl: 'https://fm.missevan.com/live/869109850',
    buttonText: '进入猫耳FM直播间',
  },
  sign_time_range_config: {
    topNum: 5,
    timeDays: 30,
    signName: '周榜',
    targetList: [
      { id: '1', targetNum: 7, targetDescription: '免费一首自带歌曲 随机抽取' },
      { id: '2', targetNum: 15, targetDescription: '指定一首歌曲（非新歌）' },
      { id: '3', targetNum: 30, targetDescription: '指定一首新歌翻唱' },
      { id: '4', targetNum: 52, targetDescription: '炒粉神秘一阶奖励' },
      { id: '5', targetNum: 66, targetDescription: '炒粉神秘二阶奖励+节日专属投稿x1' },
      { id: '6', targetNum: 100, targetDescription: '定制专属歌曲一首（含编曲）' },
      { id: '7', targetNum: 200, targetDescription: '神秘终极大奖' },
    ],
  },
};

// ================================================================
// Mock 数据 - 歌手及歌单
// ================================================================
const MOCK_SINGERS = [
  {
    id: 'singer-mock-1',
    name: '小辞',
    timbre: '磁性, 温暖',
    genre: '说唱, 流行',
    schedule: '16:00-24:00',
    avatar: 'https://givelove.cn/img/20260802231931.jpg',
    order: 0,
    homepage: 'https://example.com/xiaoci',
    songs: [
      { id: 'song-1-1', title: '患', image: '', note: '代表作', genre: '流行', originalSinger: '' },
      { id: 'song-1-2', title: '玩家', image: '', note: '', genre: '流行', originalSinger: '' },
      { id: 'song-1-3', title: '信仰', image: '', note: '', genre: '流行', originalSinger: '' },
      { id: 'song-1-4', title: '星梦', image: '', note: '', genre: '流行', originalSinger: '' },
      { id: 'song-1-5', title: '晚风', image: '', note: '治愈系', genre: '流行', originalSinger: '' },
      { id: 'song-1-6', title: '囚牢', image: '', note: '', genre: '说唱', originalSinger: '' },
      { id: 'song-1-7', title: '噩梦', image: '', note: '', genre: '说唱', originalSinger: '' },
      { id: 'song-1-8', title: '浪漫主义', image: '', note: '', genre: '流行', originalSinger: '' },
      { id: 'song-1-9', title: '关于小熊', image: '', note: '经典', genre: '说唱', originalSinger: '' },
      { id: 'song-1-10', title: 'All the way up', image: '', note: '', genre: '英文', originalSinger: '' },
    ],
  },
  {
    id: 'singer-mock-2',
    name: 'Ab',
    timbre: '性感, 沙哑',
    genre: '小众, 英文',
    schedule: '18:00-24:00',
    avatar: 'https://givelove.cn/img/20260802231931.jpg',
    order: 1,
    homepage: 'https://example.com/ab',
    songs: [
      { id: 'song-2-1', title: 'Bad Guy', image: '', note: '', genre: '英文', originalSinger: 'Billie Eilish' },
      { id: 'song-2-2', title: 'Yellow', image: '', note: '经典英文', genre: '英文', originalSinger: 'Coldplay' },
      { id: 'song-2-3', title: 'Perfect', image: '', note: '', genre: '英文', originalSinger: 'Ed Sheeran' },
      { id: 'song-2-4', title: 'Shape Of You', image: '', note: '', genre: '英文', originalSinger: 'Ed Sheeran' },
      { id: 'song-2-5', title: 'Counting Stars', image: '', note: '', genre: '英文', originalSinger: 'OneRepublic' },
      { id: 'song-2-6', title: 'Let Her Go', image: '', note: '', genre: '英文', originalSinger: 'Passenger' },
      { id: 'song-2-7', title: 'The Scientist', image: '', note: '', genre: '英文', originalSinger: 'Coldplay' },
      { id: 'song-2-8', title: 'Freedom', image: '', note: '', genre: '英文', originalSinger: '' },
    ],
  },
  {
    id: 'singer-mock-3',
    name: 'coffee',
    timbre: '温柔, 治愈',
    genre: '民谣, 爵士',
    schedule: '14:00-20:00',
    avatar: 'https://givelove.cn/img/20260802231931.jpg',
    order: 2,
    homepage: '',
    songs: [
      { id: 'song-3-1', title: '夏日晚风', image: '', note: '', genre: '民谣', originalSinger: '' },
      { id: 'song-3-2', title: '橘子汽水', image: '', note: '甜甜的', genre: '民谣', originalSinger: '' },
      { id: 'song-3-3', title: '海边探戈', image: '', note: '', genre: '爵士', originalSinger: '' },
      { id: 'song-3-4', title: '晚风', image: '', note: '', genre: '民谣', originalSinger: '' },
      { id: 'song-3-5', title: '理想女友', image: '', note: '', genre: '民谣', originalSinger: '' },
      { id: 'song-3-6', title: '最甜情歌', image: '', note: '', genre: '流行', originalSinger: '' },
    ],
  },
  {
    id: 'singer-mock-4',
    name: '火锅',
    timbre: '活泼, 元气',
    genre: '流行, 甜歌',
    schedule: '20:00-24:00',
    avatar: 'https://givelove.cn/img/20260802231931.jpg',
    order: 3,
    homepage: 'https://example.com/huoguo',
    songs: [
      { id: 'song-4-1', title: '爱你', image: '', note: '', genre: '流行', originalSinger: '王心凌' },
      { id: 'song-4-2', title: '日不落', image: '', note: '', genre: '流行', originalSinger: '蔡依林' },
      { id: 'song-4-3', title: '告白气球', image: '', note: '甜歌必点', genre: '流行', originalSinger: '周杰伦' },
      { id: 'song-4-4', title: '小幸运', image: '', note: '', genre: '流行', originalSinger: '田馥甄' },
      { id: 'song-4-5', title: '简单爱', image: '', note: '', genre: '流行', originalSinger: '周杰伦' },
    ],
  },
  {
    id: 'singer-mock-5',
    name: '象牙舟',
    timbre: '清冷, 故事感',
    genre: '古风, 民谣',
    schedule: '12:00-18:00',
    avatar: 'https://givelove.cn/img/20260802231931.jpg',
    order: 4,
    homepage: '',
    songs: [
      { id: 'song-5-1', title: '年轮', image: '', note: '', genre: '古风', originalSinger: '张碧晨' },
      { id: 'song-5-2', title: '凉凉', image: '', note: '古风经典', genre: '古风', originalSinger: '张碧晨/杨宗纬' },
      { id: 'song-5-3', title: '牵丝戏', image: '', note: '', genre: '古风', originalSinger: '银临/Aki阿杰' },
      { id: 'song-5-4', title: '离人愁', image: '', note: '', genre: '古风', originalSinger: '' },
      { id: 'song-5-5', title: '红昭愿', image: '', note: '', genre: '古风', originalSinger: '' },
      { id: 'song-5-6', title: '缘分一道桥', image: '', note: '', genre: '古风', originalSinger: '' },
    ],
  },
  {
    id: 'singer-mock-6',
    name: '青蛙',
    timbre: '少年音, 清澈',
    genre: '流行, 抒情',
    schedule: '10:00-16:00',
    avatar: 'https://givelove.cn/img/20260802231931.jpg',
    order: 5,
    homepage: 'https://example.com/qingwa',
    songs: [
      { id: 'song-6-1', title: '晴天', image: '', note: '', genre: '流行', originalSinger: '周杰伦' },
      { id: 'song-6-2', title: '稻香', image: '', note: '', genre: '流行', originalSinger: '周杰伦' },
      { id: 'song-6-3', title: '七里香', image: '', note: '经典', genre: '流行', originalSinger: '周杰伦' },
      { id: 'song-6-4', title: '安静', image: '', note: '', genre: '流行', originalSinger: '周杰伦' },
      { id: 'song-6-5', title: '夜曲', image: '', note: '', genre: '流行', originalSinger: '周杰伦' },
      { id: 'song-6-6', title: '彩虹', image: '', note: '', genre: '流行', originalSinger: '周杰伦' },
      { id: 'song-6-7', title: '简单爱', image: '', note: '', genre: '流行', originalSinger: '周杰伦' },
    ],
  },
  {
    id: 'singer-mock-7',
    name: '沐沐',
    timbre: '甜美, 可爱',
    genre: '流行, 二次元',
    schedule: '19:00-23:00',
    avatar: 'https://givelove.cn/img/20260802231931.jpg',
    order: 6,
    homepage: '',
    songs: [
      { id: 'song-7-1', title: '恋爱循环', image: '', note: '甜度爆表', genre: '二次元', originalSinger: '花泽香菜' },
      { id: 'song-7-2', title: '勾指起誓', image: '', note: '', genre: '二次元', originalSinger: '' },
      { id: 'song-7-3', title: '威风堂堂', image: '', note: '', genre: '二次元', originalSinger: '' },
      { id: 'song-7-4', title: '好想好想你', image: '', note: '', genre: '流行', originalSinger: '' },
      { id: 'song-7-5', title: '有点甜', image: '', note: '', genre: '流行', originalSinger: '汪苏泷/By2' },
      { id: 'song-7-6', title: '123我爱你', image: '', note: '', genre: '流行', originalSinger: '' },
      { id: 'song-7-7', title: '学猫叫', image: '', note: '卖萌神曲', genre: '流行', originalSinger: '' },
    ],
  },
  {
    id: 'singer-mock-8',
    name: '夜白',
    timbre: '低沉, 磁性',
    genre: '流行, R&B',
    schedule: '21:00-02:00',
    avatar: 'https://givelove.cn/img/20260802231931.jpg',
    order: 7,
    homepage: 'https://example.com/yebai',
    songs: [
      { id: 'song-8-1', title: '普通朋友', image: '', note: '', genre: 'R&B', originalSinger: '陶喆' },
      { id: 'song-8-2', title: '爱很简单', image: '', note: '经典R&B', genre: 'R&B', originalSinger: '陶喆' },
      { id: 'song-8-3', title: '江南', image: '', note: '', genre: '流行', originalSinger: '林俊杰' },
      { id: 'song-8-4', title: '修炼爱情', image: '', note: '', genre: '流行', originalSinger: '林俊杰' },
      { id: 'song-8-5', title: '她说', image: '', note: '', genre: '流行', originalSinger: '林俊杰' },
      { id: 'song-8-6', title: '搁浅', image: '', note: '', genre: '流行', originalSinger: '周杰伦' },
      { id: 'song-8-7', title: '枫', image: '', note: '深秋感', genre: '流行', originalSinger: '周杰伦' },
    ],
  },
  {
    id: 'singer-mock-9',
    name: '花间',
    timbre: '柔美, 空灵',
    genre: '古风, 流行',
    schedule: '15:00-21:00',
    avatar: 'https://givelove.cn/img/20260802231931.jpg',
    order: 8,
    homepage: '',
    songs: [
      { id: 'song-9-1', title: '不谓侠', image: '', note: '', genre: '古风', originalSinger: '' },
      { id: 'song-9-2', title: '半壶纱', image: '', note: '空灵古风', genre: '古风', originalSinger: '' },
      { id: 'song-9-3', title: '芒种', image: '', note: '', genre: '古风', originalSinger: '' },
      { id: 'song-9-4', title: '千丝戏', image: '', note: '', genre: '古风', originalSinger: '' },
      { id: 'song-9-5', title: '锦鲤抄', image: '', note: '', genre: '古风', originalSinger: '银临' },
      { id: 'song-9-6', title: '眉间雪', image: '', note: '', genre: '古风', originalSinger: '' },
      { id: 'song-9-7', title: '明月天涯', image: '', note: '古风燃曲', genre: '古风', originalSinger: '' },
    ],
  },
  {
    id: 'singer-mock-10',
    name: '阿泽',
    timbre: '清亮, 高亢',
    genre: '摇滚, 流行',
    schedule: '20:00-01:00',
    avatar: 'https://givelove.cn/img/20260802231931.jpg',
    order: 9,
    homepage: 'https://example.com/aze',
    songs: [
      { id: 'song-10-1', title: '山海', image: '', note: '', genre: '摇滚', originalSinger: '草东没有派对' },
      { id: 'song-10-2', title: '大风吹', image: '', note: '摇滚新星', genre: '摇滚', originalSinger: '草东没有派对' },
      { id: 'song-10-3', title: '你要跳舞吗', image: '', note: '', genre: '摇滚', originalSinger: '新裤子' },
      { id: 'song-10-4', title: '火车驶向云外', image: '', note: '', genre: '摇滚', originalSinger: '理想后花园' },
      { id: 'song-10-5', title: '夜空中最亮的星', image: '', note: '励志经典', genre: '流行', originalSinger: '逃跑计划' },
      { id: 'song-10-6', title: '再见', image: '', note: '', genre: '流行', originalSinger: '张震岳' },
      { id: 'song-10-7', title: '后来', image: '', note: '', genre: '流行', originalSinger: '刘若英' },
    ],
  },
  {
    id: 'singer-mock-11',
    name: '鹿鸣',
    timbre: '温暖, 治愈',
    genre: '民谣, 流行',
    schedule: '13:00-19:00',
    avatar: 'https://givelove.cn/img/20260802231931.jpg',
    order: 10,
    homepage: '',
    songs: [
      { id: 'song-11-1', title: '成都', image: '', note: '民谣经典', genre: '民谣', originalSinger: '赵雷' },
      { id: 'song-11-2', title: '南山南', image: '', note: '', genre: '民谣', originalSinger: '马頔' },
      { id: 'song-11-3', title: '理想三旬', image: '', note: '', genre: '民谣', originalSinger: '陈鸿宇' },
      { id: 'song-11-4', title: '安和桥', image: '', note: '', genre: '民谣', originalSinger: '宋冬野' },
      { id: 'song-11-5', title: '借我', image: '', note: '', genre: '民谣', originalSinger: '谢春花' },
      { id: 'song-11-6', title: '春风十里', image: '', note: '温暖治愈', genre: '民谣', originalSinger: '鹿先森乐队' },
    ],
  },
  {
    id: 'singer-mock-12',
    name: '南鸢',
    timbre: '慵懒, 迷人',
    genre: '爵士, 蓝调',
    schedule: '22:00-03:00',
    avatar: 'https://givelove.cn/img/20260802231931.jpg',
    order: 11,
    homepage: 'https://example.com/nanyuan',
    songs: [
      { id: 'song-12-1', title: 'Fly Me To The Moon', image: '', note: '爵士经典', genre: '爵士', originalSinger: '' },
      { id: 'song-12-2', title: 'L-O-V-E', image: '', note: '', genre: '爵士', originalSinger: 'Nat King Cole' },
      { id: 'song-12-3', title: 'Dream A Little Dream', image: '', note: '', genre: '爵士', originalSinger: '' },
      { id: 'song-12-4', title: 'Close To You', image: '', note: '慵懒午后', genre: '爵士', originalSinger: 'Carpenters' },
      { id: 'song-12-5', title: '给我一个吻', image: '', note: '', genre: '爵士', originalSinger: '' },
      { id: 'song-12-6', title: '夜来香', image: '', note: '经典蓝调', genre: '蓝调', originalSinger: '' },
      { id: 'song-12-7', title: '我要你的爱', image: '', note: '', genre: '爵士', originalSinger: '' },
    ],
  }
];

// ================================================================
// Mock 数据 - 用户历史信息（欢迎页预取）
// ================================================================
const MOCK_USER_INFO = {
  deviceId: 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx',
  nickname: '小辞',
  signPointNumber: 28,
};

// ================================================================
// Mock 数据 - 签到记录
// ================================================================
const MOCK_SIGN_INFO = {
  signDates: (function () {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const dates = [];
    // 生成更多签到日期，覆盖60%的天数
    for (let d = 1; d <= 30; d++) {
      if (Math.random() < 0.6) {
        const date = new Date(year, month, d);
        dates.push(date.setHours(0, 0, 0, 0));
      }
    }
    // 确保今天和昨天已签到
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (!dates.includes(today.getTime())) dates.push(today.getTime());
    const yesterday = new Date(today.getTime() - 86400000);
    if (!dates.includes(yesterday.getTime())) dates.push(yesterday.getTime());
    // 也生成一些上个月的签到记录
    const lastMonth = month === 0 ? 11 : month - 1;
    const lastMonthYear = month === 0 ? year - 1 : year;
    for (let d = 1; d <= 28; d++) {
      if (Math.random() < 0.4) {
        const date = new Date(lastMonthYear, lastMonth, d);
        dates.push(date.setHours(0, 0, 0, 0));
      }
    }
    return dates;
  })(),
  leaderboard: [
    { nickname: '小辞', count: 28 },
    { nickname: '明月照沟渠', count: 26 },
    { nickname: '予爱小迷妹', count: 24 },
    { nickname: '听风者', count: 22 },
    { nickname: '糖炒栗子', count: 20 },
    { nickname: '星河入梦', count: 18 },
    { nickname: '晚风', count: 17 },
    { nickname: '橘子汽水', count: 15 },
    { nickname: '山海', count: 13 },
    { nickname: '云间月', count: 12 },
    { nickname: '猫耳小耳朵', count: 10 },
    { nickname: '予爱粉丝', count: 9 },
    { nickname: '予爱', count: 7 },
    { nickname: '小太阳', count: 6 },
    { nickname: '追光者', count: 4 },
  ],
};

// ================================================================
// Mock 数据 - 兑换记录
// ================================================================
const MOCK_EXCHANGE_RECORDS = [
  { id: '1', targetId: '1', targetDescription: '免费一首自带歌曲 随机抽取', exchangeTime: 1722499200000, consumedPoints: 7, remainingPoints: 21, exchangeCode: 'EX20240801001A' },
  { id: '2', targetId: '1', targetDescription: '免费一首自带歌曲 随机抽取', exchangeTime: 1722585600000, consumedPoints: 7, remainingPoints: 18, exchangeCode: 'EX2024080200B2' },
  { id: '3', targetId: '2', targetDescription: '指定一首歌曲（非新歌）', exchangeTime: 1722672000000, consumedPoints: 15, remainingPoints: 66, exchangeCode: 'EX2024080300C3' },
  { id: '4', targetId: '1', targetDescription: '免费一首自带歌曲 随机抽取', exchangeTime: 1722758400000, consumedPoints: 7, remainingPoints: 14, exchangeCode: 'EX2024080400D4' },
  { id: '5', targetId: '1', targetDescription: '免费一首自带歌曲 随机抽取', exchangeTime: 1722844800000, consumedPoints: 7, remainingPoints: 28, exchangeCode: 'EX2024080500E5' },
  { id: '6', targetId: '3', targetDescription: '指定一首新歌翻唱', exchangeTime: 1722931200000, consumedPoints: 30, remainingPoints: 12, exchangeCode: 'EX2024080600F6' },
  { id: '7', targetId: '1', targetDescription: '免费一首自带歌曲 随机抽取', exchangeTime: 1723017600000, consumedPoints: 7, remainingPoints: 5, exchangeCode: 'EX2024080700G7' },
  { id: '8', targetId: '2', targetDescription: '炒粉神秘一阶奖励', exchangeTime: 1723104000000, consumedPoints: 52, remainingPoints: 30, exchangeCode: 'EX2024080800H8' },
];

// ================================================================
// Mock 数据 - 抽卡结果（从 MOCK_SINGERS 中随机选一个歌手，附加 voice 信息）
// ================================================================
const MOCK_VOICES = [
  { voiceUrl: 'https://music.163.com/song/media/outer/url?id=18678679.mp3', voiceName: '试音片段 - 患' },
  { voiceUrl: 'https://music.163.com/song/media/outer/url?id=18678680.mp3', voiceName: '试音片段 - 玩家' },
  { voiceUrl: 'https://music.163.com/song/media/outer/url?id=18678681.mp3', voiceName: '试音片段 - 晚风' },
  { voiceUrl: 'https://music.163.com/song/media/outer/url?id=18678682.mp3', voiceName: '试音片段 - 星梦' },
  { voiceUrl: 'https://music.163.com/song/media/outer/url?id=18678683.mp3', voiceName: '试音片段 - Bad Guy' },
  { voiceUrl: 'https://music.163.com/song/media/outer/url?id=18678684.mp3', voiceName: '试音片段 - Yellow' },
  { voiceUrl: 'https://music.163.com/song/media/outer/url?id=18678685.mp3', voiceName: '试音片段 - 夏日晚风' },
  { voiceUrl: 'https://music.163.com/song/media/outer/url?id=18678686.mp3', voiceName: '试音片段 - 爱你' },
  { voiceUrl: 'https://music.163.com/song/media/outer/url?id=18678687.mp3', voiceName: '试音片段 - 年轮' },
  { voiceUrl: 'https://music.163.com/song/media/outer/url?id=18678688.mp3', voiceName: '试音片段 - 晴天' },
  { voiceUrl: 'https://music.163.com/song/media/outer/url?id=18678689.mp3', voiceName: '试音片段 - 关于小熊' },
  { voiceUrl: 'https://music.163.com/song/media/outer/url?id=18678690.mp3', voiceName: '试音片段 - 告白气球' },
];

// ================================================================
// Mock 数据 - 抽卡记录（今日数据 + 历史数据）
// ================================================================
const MOCK_DRAW_RECORDS = [];

// 初始化抽卡 mock 记录（基于 MOCK_SINGERS 生成历史记录）
(function initDrawRecords() {
  if (MOCK_DRAW_RECORDS.length > 0) return;
  // 为每个歌手生成 0-3 条随机音频的抽卡记录
  MOCK_SINGERS.forEach(function (singer) {
    const voiceCount = 1 + Math.floor(Math.random() * 3); // 1-3 条
    for (var i = 0; i < voiceCount; i++) {
      const v = MOCK_VOICES[Math.floor(Math.random() * MOCK_VOICES.length)];
      const existing = MOCK_DRAW_RECORDS.find(function (r) {
        return r.id === singer.id && r.voices && r.voices.some(function (vv) { return vv.voiceUrl === v.voiceUrl; });
      });
      if (existing) {
        // 同一音频 count+1
        existing.voices.find(function (vv) { return vv.voiceUrl === v.voiceUrl; }).count += 1;
      } else {
        // 新增记录
        const singerRecord = MOCK_DRAW_RECORDS.find(function (r) { return r.id === singer.id; });
        if (singerRecord) {
          singerRecord.voices.push({ voiceUrl: v.voiceUrl, voiceName: v.voiceName, count: 1 });
        } else {
          MOCK_DRAW_RECORDS.push({
            id: singer.id,
            name: singer.name,
            timbre: singer.timbre,
            genre: singer.genre,
            schedule: singer.schedule,
            avatar: singer.avatar,
            order: singer.order,
            voices: [{ voiceUrl: v.voiceUrl, voiceName: v.voiceName, count: 1 }],
          });
        }
      }
    }
  });
  // 按 order 排序
  MOCK_DRAW_RECORDS.sort(function (a, b) {
    const oa = typeof a.order === 'number' ? a.order : 999;
    const ob = typeof b.order === 'number' ? b.order : 999;
    return oa - ob;
  });
})();

// 是否已模拟今日抽卡（默认 false，表示今天尚未抽卡）
// 改为 true 可测试"今日已抽卡"场景；改为 'empty' 可测试"今日抽了空卡"场景
let MOCK_DRAWN_TODAY = false;

// 切换今日抽卡状态的便捷方法（开发调试用）
// 在浏览器控制台执行：window.__setDrawToday('normal') | 'empty' | 'none'
if (typeof window !== 'undefined') {
  window.__setDrawToday = function (mode) {
    if (mode === 'none') {
      MOCK_DRAWN_TODAY = false;
    } else if (mode === 'empty') {
      MOCK_DRAWN_TODAY = 'empty';
    } else {
      MOCK_DRAWN_TODAY = true;
    }
  };
}

// ================================================================
// 工具函数
// ================================================================
function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

// 生成随机 UUID
function generateUuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// 稳定的匿名设备 ID：优先级 链接参数 > localStorage > 新生成
function getDeviceId() {
  // 优先从 URL 参数读取
  const params = new URLSearchParams(window.location.search);
  const urlDeviceId = params.get('deviceId');
  if (urlDeviceId && /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(urlDeviceId)) {
    localStorage.setItem('sign_device_id', urlDeviceId);
    return urlDeviceId;
  }

  let deviceId = localStorage.getItem('sign_device_id');
  if (!deviceId) {
    deviceId = generateUuid();
    localStorage.setItem('sign_device_id', deviceId);
  }
  return deviceId;
}

// 响应拦截：统一处理后端返回的 { code, data, msg } 结构
function handleResponse(res) {
  const body = res.data;
  if (body.code && body.code !== 200) {
    throw new Error(body.msg || '请求失败');
  }
  return body.data;
}

// ================================================================
// API 封装
// ================================================================
const API = {
  async getConfig() {
    if (USE_MOCK) {
      await delay(200);
      return JSON.parse(JSON.stringify(MOCK_CONFIG));
    }
    const res = await request.get('/api/config');
    return handleResponse(res);
  },

  async getSingers() {
    if (USE_MOCK) {
      await delay(300);
      return JSON.parse(JSON.stringify(MOCK_SINGERS));
    }
    const res = await request.get('/api/singers');
    return handleResponse(res);
  },

  // 获取用户历史信息（设备ID + 上次昵称 + 签到积分）
  async getUserInfo() {
    if (USE_MOCK) {
      await delay(200);
      return JSON.parse(JSON.stringify(MOCK_USER_INFO));
    }
    const res = await request.get('/api/user/info');
    return handleResponse(res);
  },

  // 获取签到记录（签到日期 + 排行榜）
  async getSignInfo() {
    if (USE_MOCK) {
      await delay(200);
      return JSON.parse(JSON.stringify(MOCK_SIGN_INFO));
    }
    const res = await request.get('/api/sign/info');
    return handleResponse(res);
  },

  // 用户签到
  async signCheckin(nickname) {
    if (USE_MOCK) {
      await delay(200);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (MOCK_SIGN_INFO.signDates.includes(today.getTime())) {
        return { signed: false, date: today.getTime(), message: '今日已签到' };
      }
      MOCK_SIGN_INFO.signDates.push(today.getTime());
      const existing = MOCK_SIGN_INFO.leaderboard.find(function (item) { return item.nickname === nickname; });
      if (existing) {
        existing.count += 1;
      } else {
        MOCK_SIGN_INFO.leaderboard.push({ nickname: nickname, count: 1 });
      }
      return { signed: true, date: today.getTime(), message: '签到成功' };
    }
    const res = await request.post('/api/sign/checkin', { nickname: nickname });
    return handleResponse(res);
  },

  // 每日抽卡
  async drawCard() {
    if (USE_MOCK) {
      await delay(500);
      // 如果今日已抽卡，返回错误
      if (MOCK_DRAWN_TODAY) {
        throw new Error('今日已抽卡，请明天再来');
      }
      // 30% 概率抽到空卡（暂无试音数据）
      if (Math.random() < 0.3) {
        MOCK_DRAWN_TODAY = 'empty';
        return null;
      }
      // 随机选择一个歌手
      const singer = MOCK_SINGERS[Math.floor(Math.random() * MOCK_SINGERS.length)];
      const voice = MOCK_VOICES[Math.floor(Math.random() * MOCK_VOICES.length)];
      const result = {
        id: singer.id,
        name: singer.name,
        timbre: singer.timbre,
        genre: singer.genre,
        schedule: singer.schedule,
        avatar: singer.avatar,
        order: singer.order,
        voice: {
          voiceUrl: voice.voiceUrl,
          voiceName: voice.voiceName,
        },
      };
      // 记录到 mock 历史
      const singerRecord = MOCK_DRAW_RECORDS.find(function (r) { return r.id === singer.id; });
      if (singerRecord) {
        const existingVoice = singerRecord.voices.find(function (v) { return v.voiceUrl === voice.voiceUrl; });
        if (existingVoice) {
          existingVoice.count += 1;
        } else {
          singerRecord.voices.push({ voiceUrl: voice.voiceUrl, voiceName: voice.voiceName, count: 1 });
        }
      } else {
        MOCK_DRAW_RECORDS.push({
          id: singer.id,
          name: singer.name,
          timbre: singer.timbre,
          genre: singer.genre,
          schedule: singer.schedule,
          avatar: singer.avatar,
          order: singer.order,
          voices: [{ voiceUrl: voice.voiceUrl, voiceName: voice.voiceName, count: 1 }],
        });
      }
      MOCK_DRAWN_TODAY = true;
      return result;
    }
    const res = await request.post('/api/draw');
    return handleResponse(res);
  },

  // 查询抽卡记录（今日数据 + 历史数据）
  async getDrawRecords() {
    if (USE_MOCK) {
      await delay(200);
      // 构建今日记录
      let todayRecord = null;
      if (MOCK_DRAWN_TODAY === 'empty') {
        // 今日抽了空卡：仅 id 有值，其余属性为空
        todayRecord = {
          id: 'empty-today',
          name: null,
          timbre: null,
          genre: null,
          schedule: null,
          avatar: null,
          order: null,
          voice: null,
        };
      } else if (MOCK_DRAWN_TODAY) {
        // 今日抽到了歌手：从历史记录中取第一条的歌手信息构造
        const firstRecord = MOCK_DRAW_RECORDS[0];
        if (firstRecord) {
          todayRecord = {
            id: firstRecord.id,
            name: firstRecord.name,
            timbre: firstRecord.timbre,
            genre: firstRecord.genre,
            schedule: firstRecord.schedule,
            avatar: firstRecord.avatar,
            order: firstRecord.order,
            voice: firstRecord.voices && firstRecord.voices.length > 0
              ? { voiceUrl: firstRecord.voices[0].voiceUrl, voiceName: firstRecord.voices[0].voiceName }
              : null,
          };
        }
      }
      return {
        todayRecord: todayRecord,
        historyRecords: JSON.parse(JSON.stringify(MOCK_DRAW_RECORDS)),
      };
    }
    const res = await request.get('/api/draw/records');
    return handleResponse(res);
  },

  // 兑换签到奖励
  async exchangeReward(targetId) {
    if (USE_MOCK) {
      await delay(200);
      // 模拟签到天数不足的情况
      const target = MOCK_CONFIG.sign_time_range_config.targetList.find(function (t) { return t.id === targetId; });
      if (!target) {
        return { success: false, message: '奖励目标不存在' };
      }
      if (MOCK_USER_INFO.signPointNumber < target.targetNum) {
        return { success: false, message: '签到天数不足，无法兑换该奖励' };
      }
      const exchangeCode = 'EX' + new Date().toISOString().slice(0, 10).replace(/-/g, '') + String(Math.random()).slice(2, 8).toUpperCase();
      MOCK_EXCHANGE_RECORDS.push({
        id: String(Date.now()),
        targetId: targetId,
        targetDescription: target.targetDescription,
        exchangeTime: Date.now(),
        consumedPoints: target.targetNum,
        remainingPoints: MOCK_USER_INFO.signPointNumber - target.targetNum,
        exchangeCode: exchangeCode,
      });
      MOCK_USER_INFO.signPointNumber -= target.targetNum;
      return { success: true, message: '兑换成功，已获得：' + target.targetDescription, exchangeCode: exchangeCode };
    }
    const res = await request.post('/api/sign/exchange', { targetId: targetId });
    return handleResponse(res);
  },

  // 查询兑换记录
  async getExchangeRecords() {
    if (USE_MOCK) {
      await delay(200);
      return JSON.parse(JSON.stringify(MOCK_EXCHANGE_RECORDS));
    }
    const res = await request.get('/api/sign/exchange-records');
    return handleResponse(res);
  },
};

export default API;